<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Klienter</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact">
                <mat-card-content>
                    <app-application-clients-list
                        [query]="query"
                        [page]="page"
                        (filterChanged)="updateQueryParameters($event)"></app-application-clients-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>

